// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const { configureSession, render } = require('client-v2/common/client')
// Entry imports
const configureStore = require('client-v2/logged-out-landing/state/store')
const rootFactory = require('client-v2/logged-out-landing/components/root').factory
// Sibling imports
const loggedOutBannerActions = require('./containers/banner-section/actions')

const { store } = render(configureStore, rootFactory)

configureSession(store, {
  pageName: 'stream.profile'
})

businessEvents.trackInternal('pageview')
businessEvents.trackSegment('pageview')

const initialState = store.getState()
const { pathname, search } = initialState.router.location
const queryParams = qs.parse(search, { ignoreQueryPrefix: true })
if (pathname === '/add' || pathname === '/mixit') {
  // Handle `/add` and `/mixit` modal route behaviors
  const url = queryParams.url || queryParams.source
  if (url) {
    store.dispatch(loggedOutBannerActions.show(url))
  }
}
